import { useLocale } from '@koopajs/react';

export const getEmailReminderOptions = (
  keyPrefix: string,
  dateOptions: number[] = [0.25, 1, 3, 7]
): Array<{ id: string; label: string }> => {
  const { t } = useLocale();
  return dateOptions.map((option) => {
    let label = 'optionLabelDays';
    let count = option;
    if (option > 0 && option < 1) {
      label = 'optionLabelHours';
      count = option * 24;
    }
    return {
      id: `${option}`,
      label: t(`${keyPrefix}.Form.RadioFields.${label}`, { count })
    };
  });
};
